var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('va-list',{attrs:{"filters":_vm.filters,"disable-create":"","disable-export":"","include":['recommendation', 'recommendation_priority_entity']}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-select":"","disable-actions":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }